import { Link } from 'react-router-dom';
import type { Episode } from '@/mocks/episodes';

interface EpisodeDirectoryProps {
  episodes: Episode[];
}

export default function EpisodeDirectory({ episodes }: EpisodeDirectoryProps) {
  const aired = episodes.filter((e) => e.aired);
  const upcoming = episodes.filter((e) => !e.aired);

  return (
    <div className="w-full">
      <div className="flex items-center gap-3 mb-5">
        <h3 className="text-base font-semibold text-foreground-950 flex items-center gap-2">
          <i className="ri-list-check-2 text-primary-700"></i>
          已播出章节
        </h3>
        <span className="text-xs text-foreground-500">
          共 <span className="font-label text-primary-700">{aired.length}</span> 集
        </span>
      </div>

      {aired.length > 0 ? (
        <div className="grid grid-cols-3 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-8 gap-2">
          {aired.map((episode) => (
            <Link
              key={episode.id}
              to={`/play/${episode.id}`}
              className={`relative h-11 rounded-md flex items-center justify-center text-sm font-label border transition-colors ${
                episode.isNew
                  ? 'bg-accent-500 border-accent-500 text-background-50 dark:text-foreground-950'
                  : 'bg-background-100 border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
              }`}
              title={episode.title}
            >
              {episode.number}
              {episode.isNew && (
                <span className="absolute -top-1.5 -right-1.5 w-2.5 h-2.5 rounded-full bg-accent-500 border-2 border-background-50"></span>
              )}
            </Link>
          ))}
        </div>
      ) : (
        <p className="text-sm text-foreground-500">暂无已播出章节。</p>
      )}

      {upcoming.length > 0 && (
        <>
          <div className="flex items-center gap-3 mt-8 mb-4">
            <h3 className="text-base font-semibold text-foreground-950 flex items-center gap-2">
              <i className="ri-time-line text-secondary-600"></i>
              待更新章节
            </h3>
            <span className="text-xs text-foreground-500">
              共 <span className="font-label text-secondary-700">{upcoming.length}</span> 集
            </span>
          </div>
          <div className="grid grid-cols-3 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-8 gap-2">
            {upcoming.map((episode) => (
              <div
                key={episode.id}
                className="h-11 rounded-md flex items-center justify-center text-sm font-label border border-dashed border-background-300 bg-background-50 text-foreground-400 cursor-default"
                title={`第${episode.number}集 待更新`}
              >
                {episode.number}
              </div>
            ))}
          </div>
          <p className="mt-3 text-xs text-foreground-500 flex items-center gap-1.5">
            <i className="ri-information-line"></i>
            待更新章节将在播出后同步上线，敬请关注最新更新列表。
          </p>
        </>
      )}
    </div>
  );
}